import { FC } from 'react';
import { NumberUtils, Tr } from '@utils';
import { Site } from '@services';
import { Box, Grid } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';

export interface ILocationViewDialogProps extends IVoltaageModalDialogProps {
	entity?: Site;
}

export const LocationViewDialog: FC<ILocationViewDialogProps> = ({ entity, ...props }) => {
	return (
		<VoltaageModalDialog title={<Tr.Portal path="location.add-edit-view-location-modal-title" />} dividers {...props}>
			<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
				<Grid container>
					<StripedTableCell title={<Tr.Portal path="location.location-name" />}>{entity?.name || '-'}</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="location.address" />}>{entity?.address || '-'}</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="location.gasoline-price" />} greyBg>
						{NumberUtils.formatAsPrice(entity?.gasolinePrice, { pureDefault: true })}
					</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="location.diesel-price" />} greyBg>
						{NumberUtils.formatAsPrice(entity?.dieselPrice, { pureDefault: true })}
					</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="location.gpl-price" />}>
						{NumberUtils.formatAsPrice(entity?.gplPrice, { pureDefault: true })}
					</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="location.natural-gas-price" />}>
						{NumberUtils.formatAsPrice(entity?.naturalGasPrice, { pureDefault: true })}
					</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="location.electricity-price" />} greyBg>
						{NumberUtils.formatAsPrice(entity?.electricityPrice, { pureDefault: true })}
					</StripedTableCell>
					<StripedTableCell greyBg />
				</Grid>
			</Box>
		</VoltaageModalDialog>
	);
};
